import { render, staticRenderFns } from "./mock.vue?vue&type=template&id=bd4761d8&scoped=true"
import script from "./mock.vue?vue&type=script&lang=js"
export * from "./mock.vue?vue&type=script&lang=js"
import style0 from "./mock.vue?vue&type=style&index=0&id=bd4761d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4761d8",
  null
  
)

export default component.exports